import { VodafoneTariffState } from '@tymbe/schema/enums';
import { VodafoneTariffTable } from './components/VodafoneTariffTable';

export const notPaidVodafoneTariffQueryId = 'admin/vodafoneTariff/notPaid';

export const NotPaidTab = () => {
  return (
    <VodafoneTariffTable
      queryId={notPaidVodafoneTariffQueryId}
      state={VodafoneTariffState.PAYMENT_PENDING}
      tabName="not-paid"
    />
  );
};
